<template>
  <div class="ec-block" :class="cls">
    <div class="ec-block__head">
      <i class="icon--right"></i>
      <div class="ec-block__title">
        {{title}}
      </div>
      <ec-tag :tagTxt="tagTxt"></ec-tag>
    </div>
    <div class="ec-block__content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import EcTag from './EcTag'
export default {
  name: 'EcBlock',
  props: {
    tagTxt: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    cls: {
      type: String,
      default: ''
    }
  },
  components: {
    EcTag
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/theme/variables.scss";
.ec-block {
  padding: 6px 10px 4px;
  background: $dataIndexBlockBg;
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
  &__head {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    color: #00ffe4;
    height: 18px;
  }
  &__title {
    font-size: 14px;
    color: #fff;
    margin-right: 4px;
  }
  &__content {
    flex-grow: 1;
    width: 100%;
    position: relative;
  }
}
.icon--right {
  -webkit-animation: bounceRight 2s infinite;
  animation: bounceRight 2s infinite;
  width: 20px;
  height: 12px;
  background: url(../../../assets/img/dataIndex-right.png) left center no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/views/dataIndex/components/EcBlock.vue